import { render, staticRenderFns } from "./RedesignFooter.vue?vue&type=template&id=36f67813&"
import script from "./RedesignFooter.vue?vue&type=script&lang=js&"
export * from "./RedesignFooter.vue?vue&type=script&lang=js&"
import style0 from "./RedesignFooter.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports